module.exports = __webpack_public_path__ + "static/media/Nidoqueen_gaussian2.67a54601.png";